import { getDatabase, get, ref, set } from "firebase/database";
import { v4 as uuid } from "uuid";

const FIREBASE_PUSH_DB_NAME = "push-notifications";

/**
 * notifyType
 *   'message' - Simple notification without user response (for 2 seconds)
 *   'response' - Notification with Accept/Reject option
 *   'notify' - Notication with Okay Button
 */

/**
 *
 * @param type 'user'
 * @param notifyData Notification Data
 * @param userIdList List of users to be notified
 */

export const notifyToUser = async (
  type: string,
  notifyData: any,
  userIdList?: any
) => {
  if (type !== "user" || userIdList == null) {
    return;
  }

  const rawList = Array.isArray(userIdList) ? userIdList : [userIdList];
  const userIds = [
    ...new Set(
      rawList
        .filter(
          (id) =>
            id !== null &&
            id !== undefined &&
            String(id).trim() !== ""
        )
        .map(String)
    ),
  ];
  if (userIds.length === 0) {
    return;
  }

  const firebaseDB = getDatabase();
  const pushNotificationRef = ref(firebaseDB, FIREBASE_PUSH_DB_NAME);
  const snapshot = await get(pushNotificationRef);
  const data = snapshot.val();
  const prevNotifyData =
    data && typeof data === "object" ? { ...data } : {};

  for (const userId of userIds) {
    const existing = prevNotifyData[userId]?.notify;
    const userNotification = Array.isArray(existing) ? [...existing] : [];
    userNotification.push({ ...notifyData, status: "unread", id: uuid() });
    await set(ref(firebaseDB, `${FIREBASE_PUSH_DB_NAME}/${userId}`), {
      notify: userNotification,
    });
  }
};

// const notifyData = {
//   fileId: this.props.fileToBeAssigned,
//   bank: "test_bank",
//   branch: "test_branch",
//   assignedTo: this.state.user,
//   assignedBy: userId,
//   notifyType: "message",
// };
// notifyToUser("user", {...notifyData,notifyType:'message'}, ["147"]);
export const updatePNFirebaseReadStatus = async (
  notificationId: string,
  userId: string,
  text: string = "",
  notificationStatus: string,
  status: string = "read"
) => {
  const firebaseDB = getDatabase();
  const pushNotificationRef = ref(firebaseDB, FIREBASE_PUSH_DB_NAME);
  const snapshot = await get(pushNotificationRef);
  const data = snapshot.val();
  const prevNotifyData = data && typeof data === "object" ? data : {};

  const existingNotify = prevNotifyData[userId]?.notify;
  let userAllNotification = Array.isArray(existingNotify)
    ? [...existingNotify]
    : [];
  const userNotificationIndex = userAllNotification.findIndex(
    (value) => value.id === notificationId
  );
  if (userNotificationIndex > -1) {
    userAllNotification[userNotificationIndex].status = status;
    userAllNotification[userNotificationIndex].notificationStatus =
      notificationStatus;
    userAllNotification[userNotificationIndex].reason = text;
    await set(ref(firebaseDB, `${FIREBASE_PUSH_DB_NAME}/${userId}`), {
      notify: userAllNotification,
    });
  }
};
